module.exports = __webpack_public_path__ + "img/TALLER TRABAJOS ESPECIALES.ebda4cd9.png";